import * as React from 'react';
import { graphql } from 'gatsby';

import PageLayout from '../components/page';
import HeadMetadata from '../components/head';
import Layout from '../components/layout';
import Footer from '../components/footer';
import HomepageModal from '../components/homepageModal';
import { getHardcodedPathByLocaleCode, getCurrentNodeByLocale } from '../utils';
import { HOST_NAME } from '../constants';

const PageHeader = () => <div></div>;

const Page = (props) => {
  const currentPath = props.location.pathname;
  const currentLocaleCode = props.pageContext?.locale;
  const currentHomePage = getHardcodedPathByLocaleCode('home', currentLocaleCode);
  const siteSettings = getCurrentNodeByLocale(
    props.data.allContentstackSiteSettings.nodes,
    currentLocaleCode
  );
  const attributes = props.data.contentstackDynamicPage.attributes || {};
  const html_id = attributes.html_id || '';
  const className = attributes.class || '';

  return (
    <>
      <a class="skip-content" href="#main_content" aria-label="Skip to Main Content" tab-index="0"><span>Skip to Main Content</span></a>
      <Layout
        header={PageHeader()}
        siblingsPages={props.pageContext?.siblingsPages}
        currentLocaleCode={currentLocaleCode}
      >
        <PageLayout
          page={props.data.contentstackDynamicPage}
          subpages={props.data.subpages.edges}
          html_id={html_id}
          className={className}
          currentLocaleCode={currentLocaleCode}
        />
        <Footer currentLocaleCode={currentLocaleCode} />
        {currentPath === currentHomePage && (
          <HomepageModal
            data={siteSettings?.newsletter_modal}
            currentLocaleCode={currentLocaleCode}
          />
        )}
      </Layout>
    </>
  );
};

export default Page;

export const Head = (props) => {
  const currentLocaleCode = props.pageContext?.locale;
  const siteSettings = getCurrentNodeByLocale(
    props.data.allContentstackSiteSettings.nodes,
    currentLocaleCode
  );

  return (
    <>
      <HeadMetadata
        title={props.data.contentstackDynamicPage.seo.title}
        description={props.data.contentstackDynamicPage.seo.description}
        keywords={props.data.contentstackDynamicPage.seo?.keywords}
        canonical={`${HOST_NAME}${props.pageContext.pagePath}`}
        seo={siteSettings?.seo}
        externalHreflangs={props.data.contentstackDynamicPage.seo?.external_hreflangs}
      />
      <body className="page basicpage dynamicPage" />
    </>
  );
};

export const pageQuery = graphql`
  query ($id: String, $pathRegex: String, $domain: String) {
    subpages: allContentstackDynamicPage(
      filter: { url: { regex: $pathRegex }, id: { ne: $id }, domain_name: { eq: $domain } }
    ) {
      edges {
        node {
          url
          cta {
            title
          }
        }
      }
    }
    contentstackDynamicPage(id: { eq: $id }) {
      locale
      url
      title
      seo {
        title
        description
        external_hreflangs {
          hreflang
          url
        }
        keywords
      }
      attributes {
        html_id
        class
      }
      modular_blocks {
        alert {
          title
          urltext
          url
        }
        links {
          link {
            image {
              url
              title
            }
            url
            urltext
          }
          layout
        }
        custom_html {
          html
        }
        accordion {
          title
          description
          layout
          items {
            title
            content
          }
        }
        tabs_items {
          title
          description
          disclaimer
          modular_blocks {
            tab {
              title
              modular_blocks {
                item {
                  title
                  file {
                    url
                  }
                }
              }
            }
          }
        }
        promo_form {
          title
          description
          form_id
          layout
          submit_error_message
        }
        columns {
          background_color
          attributes {
            class
            html_id
            style
          }
          column {
            background_color
            image {
              url
              title
              description
            }
            rich_text_editor
            title
            layout
          }
          layout
          title
        }
        product_set_page_list {
          title
          cta_title
          product_set_pages {
            title
            url
            seo {
              title
            }
            images {
              url
              title
            }
          }
        }
        content_block {
          content
          title
          attributes {
            class
            html_id
            style
          }
        }
        hero {
          background {
            url
            title
            description
          }
          background_color
          content
          content_image {
            url
            title
            description
          }
          ratio
          layout
          attributes {
            class
          }
        }
        image {
          alternative_text
          asset {
            url
            title
          }
          layout
        }
        page_list {
          title
          background_color
          pages {
            ... on Contentstack_dynamic_page {
              url
              title
              publish_details {
                date_text: time(formatString: "MMMM YYYY")
                date_number: time(formatString: "YYYY-MM-DD")
              }
              cta {
                description
                images {
                  href
                  title
                }
                title
                urltext
              }
            }
            ... on Contentstack_product_set_page {
              url
              title
              publish_details {
                date_text: time(formatString: "MMMM YYYY")
                date_number: time(formatString: "YYYY-MM-DD")
              }
              images {
                href: url
                title
              }
            }
          }
          layout
          url
          urltext
        }
        item_list {
          layout
          items {
            title
            description
            image {
              url
              title
            }
          }
        }
      }
    }

    allContentstackSiteSettings(
      filter: { domain_name: { eq: "airwick.us" }, locale: { in: ["en-us", "en-es"] } }
    ) {
      nodes {
        locale
        ...FragmentContentstackSiteSettingsSeo
        ...FragmentContentstackSiteSettingsNewsletterModal
      }
    }
  }
`;
